import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { ModalService } from 'src/app/services/modal.service';
import { HotelService } from '../../services/hotel.service';
import { GuestService } from 'src/app/services/guest.service';
import moment from 'moment-timezone';
import _ from 'lodash';
import { DateUtilityServiceService } from '../../services/date-utility-service.service';
import { VariablesService } from '../../services/variables.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ContactusComponent } from 'src/app/reusable-components/contactus/contactus.component';
import { ConstantsService } from 'src/app/services/constants.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CreditcardService } from 'src/app/services/creditcard.service';
import { LineitemService } from 'src/app/services/lineitem.service';
import { RememberService } from 'src/app/services/remember.service';
import { MatIconModule } from '@angular/material/icon';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
    templateUrl: './summary.component.html',
    standalone: false
})
export class SummaryComponent implements OnInit {

  isSubmitting = false;
  isError = false;
  hotelsLoaded = false;
  attendee;
  guests;
  enrollment;
  emailAddress;
  hotelList;
  dateRange;
  groupDays;
  preextend;
  postextend;
  hotelStay;
  workAddress: any;
  homeAddress: any;
  workPhone: any;
  homePhone: any;
  mobilePhone: any;
  emerContactMainPhone: any;
  emerContactAltPhone: any;
  adminContact: any;
  hotelSpecialRequests: any;
  hotelSmoking: any;
  personalDisplay: any;
  isRegComplete: any;
  shirtSize;
  shirtSizeValue;
  errorMsg;
  dietaryNeedDisplay;
  personalConsiderationsDisplay;
  mealList;
  personalConsiderationsList;
  pagesInSiteFlow: any;
  page: any;
  firstTime;
  firstTimeValue;
  isFormCompleted;
  whyAttend;
  showpayment = false;
  bestFeature;
  bestFeatureValue;
  bestFeatureFreeForm;
  bestFeatureFreeFormValue;
  bestFeatures;
  bestFeaturesSelections;
  programInfo;
  successMessage = false;
  bedding;
  ready = false;
  output:any = {
    showGlobals : false,
    config: "",
    enrollment:"",
    programKey:"",
    serviceURL:"",
    hideLimits:true,
    hideHeader:true
  };

  charges = {
    Conference: null,
    Hotel: null,
    Activity: null,
    Guest: null,
    Donation: null
  };
  payment;
  conferencePayment;
  guaranteecard;
  guaranteePayment;
  cards;
  hotelPayment;
  hotelcard;
  activityPayment;
  activitycard;
  guestPayment;
  guestcard;
  conferencecard;
  rememberme;
  isGDPR;
  departmentName;
  advisoryBoard;
  neurodiversity;
  langinterp;
  donation;
  guestTypes;
  roommate;
  roommateemail;
  roommatearrive;
  roommatedepart;
  age;
  gender;
  ethnicity;
  bizjob;
  employeenums;
  exp;
  aum;
  affiliation;
  isalt;
  isbuf;
  isemp;
  isetf;
  isnet;
  ismodel;
  issma;
  aiv;
  sma;
  breakout;
  ce;
  dccontact;
  braindate;
  bestDescribes;
  describeBusiness;
  investmentStrategies;
  harassmentPolicy;
  photoRelease;
  wealthManagementFirm;
  wealthManagementLevel;
  CFP;
  crdNumber;
  fieldManager;
  OSJ;
  considerationsAllergies;
  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    public modalService: ModalService,
    private hotelService: HotelService,
    private dateService: DateUtilityServiceService,
    private variablesService: VariablesService,
    private guestService: GuestService,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    public Constants: ConstantsService,
    private configurationService: ConfigurationService,
    private creditCardService: CreditcardService,
    private lineItemService: LineitemService,
    private rememberService: RememberService,
    private environmentService: EnvironmentService
  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.guests = this.registrationService.getGuests({});
    this.enrollment = this.registrationService.getEnrollment({});
    this.firstTime = this.registrationService.getVariable(this.attendee, this.variablesService.VARIABLE.FIRST_TIME.ID, {});
    this.departmentName = registrationService.getVariable(this.attendee,variablesService.VARIABLE.DEPARTMENT_NAME.ID,{});
    this.advisoryBoard = registrationService.getVariable(this.attendee,variablesService.VARIABLE.ADVISORY_BOARD.ID,{});
    this.neurodiversity = registrationService.getVariable(this.attendee,variablesService.VARIABLE.NEURODIVERSITY.ID,{});
    this.langinterp = registrationService.getVariable(this.attendee,variablesService.VARIABLE.LANG_INTERP.ID,{});
    this.donation = registrationService.getVariable(this.attendee,variablesService.VARIABLE.DONATION.ID,{});
    this.wealthManagementFirm = registrationService.getVariable(this.attendee,variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM.ID,{});
    this.wealthManagementLevel = registrationService.getVariable(this.attendee,variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM_LEVEL.ID,{});
    this.CFP = registrationService.getVariable(this.attendee,variablesService.VARIABLE.CFP.ID,{});
    this.crdNumber = registrationService.getVariable(this.attendee,variablesService.VARIABLE.varCRDNumber.ID,{});
    this.fieldManager = registrationService.getVariable(this.attendee,variablesService.VARIABLE.FIELD_MANAGER.ID,{});
    this.OSJ = registrationService.getVariable(this.attendee,variablesService.VARIABLE.OSJ.ID,{});

    this.roommate = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATE.ID,
      {}
    );
    this.roommateemail = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATEEMAIL.ID,
      {}
    );
    this.roommatearrive = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATEARRIVE.ID,
      {}
    );
    this.roommatedepart = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATEDEPART.ID,
      {}
    );
    this.bedding = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BEDDING.ID,
      {}
    );
    this.firstTime = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.FIRST_TIME.ID,
      {}
    );
    this.age = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AGE.ID,
      {}
    );
    this.gender = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.GENDER.ID,
      {}
    );
    this.ethnicity = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ETHNICITY.ID,
      {}
    );
    this.bizjob = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BIZJOB.ID,
      {}
    );
    this.employeenums = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.EMPLOYEENUMS.ID,
      {}
    );
    this.exp = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.EXP.ID,
      {}
    );
    this.aum = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AUM.ID,
      {}
    );
    this.affiliation = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AFFILIATION.ID,
      {}
    );
    this.isalt = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISALT.ID,
      {}
    );
    this.isbuf = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISBUF.ID,
      {}
    );
    this.isemp = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISEMP.ID,
      {}
    );
    this.isetf = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISETF.ID,
      {}
    );
    this.isnet = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISNET.ID,
      {}
    );
    this.ismodel = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISMODEL.ID,
      {}
    );
  
    this.issma = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISSMA.ID,
      {}
    );
    this.aiv = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AIV.ID,
      {}
    );
    this.sma = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.SMA.ID,
      {}
    );
    this.breakout = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BREAKOUT.ID,
      {}
    );
    this.ce = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.CE.ID,
      {}
    );
    this.dccontact = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.DCCONTACT.ID,
      {}
    );
    this.braindate = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BRAINDATE.ID,
      {}
    );
    
    this.harassmentPolicy = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.HARASSMENT_POLICY.ID,
      {}
    );
    
    this.photoRelease = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.PHOTO_RELEASE.ID,
      {}
    );
    this.investmentStrategies = "";  
    if(this.isalt.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'Alternative Investments, ';
    }
    if(this.isbuf.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'Buffered Products, ';
    }
    if(this.isemp.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'Employer Retirement Plans, ';
    }
    if(this.isetf.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'ETFs, ';
    }
    if(this.isnet.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'High Net Worth, ';
    }
    if(this.ismodel.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'Models, ';
    }
    if(this.issma.Value === 'Yes'){
      this.investmentStrategies = this.investmentStrategies + 'SMAs, ';
    }
    this.investmentStrategies = this.investmentStrategies.replace(/,\s*$/, '');

    this.bestDescribes = this.age.Value;
    if(this.enrollment.$mtcOtherGender){
      this.bestDescribes = this.bestDescribes + ', ' + this.enrollment.$mtcOtherGender;

    }else{
      this.bestDescribes = this.bestDescribes + ', ' + this.gender.Value;
    }
    if(this.enrollment.$mtcOtherEthnicity){
      this.bestDescribes = this.bestDescribes + ', ' + this.enrollment.$mtcOtherEthnicity;

    }else{
      this.bestDescribes = this.bestDescribes + ', ' + this.ethnicity.Value;

    }
    
    this.describeBusiness = this.bizjob.Value + ', ' + this.employeenums.Value + ', ' + this.exp.Value + ', ' + this.aum.Value;
    this.workAddress = this.registrationService.getAddress(this.attendee, "WORK", {});
    this.homeAddress = this.registrationService.getAddress(this.attendee, "HOME", {});
    this.workPhone = this.registrationService.getPhone(this.attendee, "WORK", {});
    this.homePhone = this.registrationService.getPhone(this.attendee, "HOME", {});
    this.mobilePhone = this.registrationService.getPhone(this.attendee, "MOBILE", {});
    this.emailAddress = this.registrationService.getEmail(this.attendee, "BUSINESS", {});
    this.emerContactMainPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "DTPHONE", {});
    this.emerContactAltPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "ALTPHONE", {});
    this.adminContact = this.registrationService.getAdminContact({});
    this.hotelSpecialRequests = this.enrollment.HotelSpecialRequests;
    this.hotelSmoking = this.attendee.HotelSmoking;
    this.output.enrollment = this.enrollment;
    this.configurationService.fetchConfig().then( conf =>{
      this.output.config = conf;
      this.output.programKey = this.environmentService.getProgramKey();
      this.output.baseURL = this.environmentService.getEnvironmentUrl("");
      this.output.actEndpoint = "service/webactivity";
      this.ready=true;
      console.log("activity output object ready");
    });

    this.cards = this.creditCardService.cards;
    this.lineItemService.getAllLineItems().subscribe(data=>{
      console.log(data);
      if(data.length>0){
        this.showpayment = true;
      }else{
        this.configurationService.fetchConfig().then((config: any) => {
          if(config.hotelGuarantee && this.registrationService.getEnrollment({}).HotelNeeded == true){
            this.showpayment = true;
          }else if(config.chargeExtensions && this.registrationService.getEnrollment({}).HotelNeeded == true && this.registrationService.getEnrollment({}).$mtcExtension){
            this.showpayment = true;
          }
        });
      }
    });
    console.log(this.showpayment);
    this.registrationService.getParticipant([]).forEach(pax=>{
      this.getDisplayName(pax);
    });
    this.payment = this.registrationService.getPayment([]);
    this.guaranteePayment = this.registrationService.getCreditCard(this.payment, "Guarantee", undefined);
    this.conferencePayment = this.registrationService.getCreditCard(this.payment, "Conference", undefined);
    this.conferencecard = this.conferencePayment && this.conferencePayment.MediaType === "CREDITCARD" ? _.filter(this.cards, {"ReferenceKey": this.conferencePayment.ReferenceKey})[0] : undefined;
    this.guaranteecard = this.guaranteePayment && this.guaranteePayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.guaranteePayment.ReferenceKey })[0] : undefined;
    this.hotelPayment = this.registrationService.getCreditCard(this.payment, "Hotel", undefined);
    this.hotelcard = this.hotelPayment && this.hotelPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.hotelPayment.ReferenceKey })[0] : undefined;
    this.activityPayment = this.registrationService.getCreditCard(this.payment, "Activity", undefined);
    this.activitycard = this.activityPayment && this.activityPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.activityPayment.ReferenceKey })[0] : undefined;
    this.guestPayment = this.registrationService.getCreditCard(this.payment, "Guest", undefined);
    this.guestcard = this.guestPayment && this.guestPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.guestPayment.ReferenceKey })[0] : undefined;

    this.isRegComplete = this.registrationService.isRegistrationComplete();

    if(this.attendee.DietaryConsiderations && this.attendee.$mtcAllergens && this.attendee.$mtcAllergens.length > 0){
      console.log(this.attendee.DietaryConsiderations);
      this.considerationsAllergies = this.attendee.$mtcAllergens.join(', ') + ', ' + this.attendee.DietaryConsiderations;
    } else if (this.attendee.DietaryConsiderations){
      this.considerationsAllergies = this.attendee.DietaryConsiderations
    } else if (this.attendee.$mtcAllergens && this.attendee.$mtcAllergens.length > 0) {
      this.considerationsAllergies = this.attendee.$mtcAllergens.join(', ')
    } 
    console.log(this.considerationsAllergies);
    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;

      if (this.attendee.DietaryNeed) {
        this.dietaryNeedDisplay = _.filter(this.mealList, { "code": this.attendee.DietaryNeed })[0].name;
        console.log(this.dietaryNeedDisplay);
        if(this.dietaryNeedDisplay == 'Food Allergy' && !this.isRegComplete && !this.attendee.DietaryConsiderations){
          this.dietaryNeedDisplay = this.dietaryNeedDisplay + ' - ' + this.attendee.$mtcAllergens.join(', ')
        }
      }
   
    });

    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;

      if (this.attendee.DisabilityType) {
        var temp;
        var final = "";
        var addedPersonalConsiderations = false;
        for (var x = 0; x < this.attendee.DisabilityType.length; x++) {
          temp = _.filter(this.personalConsiderationsList, { "code": this.attendee.DisabilityType[x] })[0].name;
          console.log(temp);
          
          if (temp === "Other"){
            final = final + temp + " - " + this.attendee.PersonalConsiderations;
            addedPersonalConsiderations = true;
          }else{
            if(temp === 'Hearing Impaired'){
              final = final + 'Deaf/Hard of Hearing';
            }else{
            final = final + temp;
            }
          }
          if (this.attendee.DisabilityType.length > 0 && x !== this.attendee.DisabilityType.length - 1) {
            final = final + ", "
          }
        }
        if(!addedPersonalConsiderations && this.attendee.PersonalConsiderations !== undefined && this.attendee.PersonalConsiderations !== ''){
          final = final +", " + this.attendee.PersonalConsiderations;
        }
        this.personalConsiderationsDisplay = final;
      }
    });

    this.listService.getPrivacyPolicyCountryList().then(list => {
      if(!this.enrollment.PrivacyPolicy) {
        this.enrollment.PrivacyPolicy = false;
      }
      this.isGDPR = false;
      for(let country of list) {
        if(country.code === this.attendee.ResidenceCountryISOCode) {
          this.isGDPR = true;
        }
      }
    });

    this.hotelStay = this.registrationService.getHotel([]);
    //check if hotel booking
    this.hotelList = { locked: false };
    if (this.enrollment.HotelNeeded) {
      this.hotelService.getHotelList().then(list => {
        this.hotelList = list;
        this.hotelsLoaded = true;
      });
    }
  }

  getDisplayName(participant) {
    var returnValue = "";
    this.listService.getPrefixValue(participant.Prefix).then(data=>{
      var prefix = data.name;
      console.log(data);
      console.log(prefix);
      if(prefix){
        returnValue = prefix + " ";
      }
      if (participant.FirstName) {
        returnValue += participant.FirstName + " ";
      }
      if (participant.MiddleName && !participant.NoMiddleNameFlag) {
        returnValue += participant.MiddleName + " ";
      }
      if (participant.LastName) {
        returnValue += participant.LastName + " ";
      }
      this.listService.getSuffixValue(participant.Suffix).then(data=>{
        var suffix = data.name;
        if(suffix && suffix !== "(None)"){
          returnValue += suffix;
        }
        if (returnValue.length <= 1) {
          returnValue = "Personal Information";
        } else {
          returnValue = returnValue.trim();
        }
        participant.$mtcDisplayName = returnValue;
      });
    });

  }


  siteFlowContains(page) {
    let index = 0; let found;
    if (this.pagesInSiteFlow) {
      for (index; index < this.pagesInSiteFlow.length; index++) {
        found = false;

        this.pagesInSiteFlow[index].forEach((entry) => {
          if (entry == '/' + page) {
            found = true;
          }
        });
        if (found) {
          break;
        }
      }
      return found;
    }
  };

  ngOnInit(): void {
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.navigationService.getNavigationList().then(pagelist => {
        this.pagesInSiteFlow = pagelist;
      });
    });
    if (this.enrollment.$mtcUpdateSuccess) {
      this.successMessage = true;
      this.enrollment.$mtcUpdateSuccess = false;
    }

    for (const key of _.keys(this.charges)) {
      this.lineItemService.getLineItems(key).subscribe({
        next: data => {
          this.charges[key] = _.reduce(data, (sum, n) => {
            return parseFloat(sum) + parseFloat(n);
          });
          },
            error: error => {
              this.Constants.ALERT_POLICY.CONTACT_SUPPORT
            }
      });
    }
    console.log(this.charges);
  }

  getGuestDiet(guest) {
    if (guest && this.mealList) {
      if (guest.DietaryNeed) {
        let diet = _.filter(this.mealList, { "code": guest.DietaryNeed })[0].name;
        if(diet != 'Food Allergy'){
          return diet
        } else if(!this.isRegComplete) {
          return diet + ' - ' + guest.$mtcAllergens.join(', ')
        } else {
          return diet + '-' + guest.DietaryConsiderations;
        }
      }
    }
  }
  getGuestTypeDisplay(guest) {
    let defaultVal = "None";
    if (!guest) {
      return defaultVal;
    }

    this.guestTypes = [
      {display: 'Adult Guest (18+) - $500', value: 11},   
      {display: 'Youth Guest (12-17) - $350', value: 12},
      {display: 'Child Guest (6-11) - $250', value: 13},
      {display: 'Young Child Guest (5 and under) - No Charge', value: 14},
      {display: 'Guest Day Pass - September 14 Opening General Session with Keynote & Welcome Reception - $250', value: 15},
      {display: 'Guest Day Pass - September 16 Final Night Concert & Party in the Park - $250', value: 16}
    ];
    
    let type = _.find(this.guestTypes, { value: guest.PAXTypeNo });
    return type ? type.display : defaultVal;
  }
  // getGuestTypeDisplay(guest) {
  //   if (guest) {
  //     return this.guestService.getTypeDisplay(guest);
  //   }
    
  // }
  getGuestCity(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.GUEST_CITY.ID,
      {}
    ).Value;
  }
  getNeuro(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.NEURODIVERSITY.ID,
      {}
    ).Value;
  }
  getGuestState(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.GUEST_STATE.ID,
      {}
    ).Value;

  }

  getGuestLang(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.LANG_INTERP.ID,
      {}
    ).Value
  }
  getGuestADAPersonal(guest) {
    if (guest && this.personalConsiderationsList) {
      if (guest.DisabilityType) {
        var addedPersonalConsiderations = false;
        var temp;
        var final = "";
        for (var x = 0; x < guest.DisabilityType.length; x++) {
          temp = _.filter(this.personalConsiderationsList, { "code": guest.DisabilityType[x] })[0].name;
          if (temp === "Other"){
            final = final + temp + " - " + guest.PersonalConsiderations;
            addedPersonalConsiderations = true;
          }else{
            if(temp === 'Hearing Impaired'){
              final = final + 'Deaf/Hard of Hearing';
            }else{
            final = final + temp;
            }
          }
          if (guest.DisabilityType.length > 0 && x !== guest.DisabilityType.length - 1) {
            final = final + ", "
          }
        }
        if(!addedPersonalConsiderations && guest.PersonalConsiderations !== undefined && guest.PersonalConsiderations !== ''){
          final = final +", " + guest.PersonalConsiderations;
        }
        return final;
      }
    }
  }

  printPage() {
    window.print();
  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openModalExternal(url, title, actionButtonText) {
    this.modalService.openModalExternal(url, title, actionButtonText);
  }

  getHotelsWithStays() {
    var hotelids = _.uniq(_.map(this.hotelStay, "Hotel"));
    var hotels = [];
    if (this.hotelList) {
      var self = this;
      hotelids.forEach((id)=> {
        var hotel = _.filter(self.hotelList.roomTypeList, { webHotelGroupID: id })[0];
        var hotelNights = self.getNightsAtHotel(hotel.webHotelGroupID);
        hotel.firstNight = hotelNights[0];
        hotels.push(hotel);
      });
    }
    return hotels;
  };

  getNightsAtHotel(hotelid) {
    // console.log(this.hotelStay);
    this.hotelStay.forEach( (hotelnight) =>{
      if (moment.isMoment(hotelnight.Date)) {
        hotelnight.Date = hotelnight.Date.toDate();
      }
    });
    // console.log(_.orderBy((_.map(_.filter(this.hotelStay, { Hotel: hotelid }), "Date"))));
    return _.orderBy((_.map(_.filter(this.hotelStay, { Hotel: hotelid }), "Date")));
  };

  getStatus(hotelobj, date) {
    var hotelnight;
    var testDate;

    if (moment.isMoment(date)) {
      testDate = date.toDate();
    } else {
      testDate = this.dateService.createMTCZoneDateTime(date).toDate();
    }
    var self = this;
    _.forEach(hotelobj.roomNightsListWithRate, (night) => {
      var nightDate = self.dateService.createMTCZoneDateTime(night.blockDate).toDate();
      var inputDate = testDate;
      if (nightDate.getTime() === inputDate.getTime()) {
        hotelnight = night;
      }
    });

    if (hotelnight.availabilityCode === 1) {
      //if night is not already booked.
      if (hotelnight.groupDateFlag === "GRP") {
        return "Confirmed";
      } else {
        return "Pending";
      }
    } else if (hotelnight.availabilityCode === 2) {
      return "Pending";
    } else if (hotelnight.availabilityCode === 3) {
      return "Confirmed";
    }
  };

  editAttendee() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else {
    this.router.navigate(['attendee']);
    }
  }
  editGuest(guest) {
    if (guest) {
      this.guestService.selectGuest(guest);
    }
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else {
      this.router.navigate(['guest']);
    }
  }
  editDemographics() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else {
    this.router.navigate(['demographics']);
    }
  }
  editHotel() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      if (this.programInfo) {
        if (this.programInfo.hotelpackage) {
          this.router.navigate(['hotelpackage']);
        } else if (this.programInfo.hotelBooking) {
          this.router.navigate(['hotelbooking']);
        } else {
          this.router.navigate(['hotel']);
        }
      }
    }
  }
  editTravel() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else {
      this.router.navigate(['travel']);
    }
  }
  editGuestTravel(guest) {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.guestService.selectGuest(guest);
      this.router.navigate(['guest-travel']);
    }
  }
  editSessions() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.router.navigate(['activity']);
    }
  }

  /**
  * @function editPayment
  * @description Sets activity path to payment page.
  */
  editPayment() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else {
    this.router.navigate(['payment']);
    }
  }

  phoneNoRipApart(phoneChunk){
    phoneChunk.forEach(phone => {
      if ( phone ) {
        if ( phone.AreaCityCode ) {
          if ( phone.AreaCityCode.length > 3 ) {
            let areaCityCode = phone.AreaCityCode.substring(0,3);
            let phoneNo = phone.AreaCityCode.substring(3);
            phone.AreaCityCode = areaCityCode;
            phone.PhoneNo = phoneNo;
          }
        }
      }

    });
  }
  setGuestDietary(){
    this.guests.forEach((guest) => {
      if(guest.DietaryConsiderations && guest.$mtcAllergens){
        guest.DietaryConsiderations = guest.$mtcAllergens.join(', ') + ', ' + guest.DietaryConsiderations;
      } else if (guest.$mtcAllergens) {
        guest.DietaryConsiderations = guest.$mtcAllergens.join(', ')
      }
    })
  }
  forward(form) {
    if (!this.isSubmitting) {
    this.isFormCompleted = true;
    this.isSubmitting = true;
    this.errorMsg = undefined;

    this.enrollment.Participant.forEach(part => {
      if ( part.Phone ) {
        this.phoneNoRipApart(part.Phone);
      }
      if ( part.EmergencyContact) {
        this.phoneNoRipApart(part.EmergencyContact.EmergencyContactPhone);
      }
    });

    if ( this.enrollment.AdminContact.AdminContactPhone ) {
      this.phoneNoRipApart(this.enrollment.AdminContact.AdminContactPhone);
    }
    
    /* if () { */
    if (form.valid ) {
      if(this.enrollment.$mtcOtherEthnicity){
        this.ethnicity.Value = this.enrollment.$mtcOtherEthnicity;

      }
      if(this.enrollment.$mtcOtherGender){
        this.gender.Value = this.enrollment.$mtcOtherGender;

      }
      this.attendee.DietaryConsiderations = this.considerationsAllergies;
      this.setGuestDietary();
      if(this.enrollment.HotelSpecialRequests && this.bedding.Value){
        this.enrollment.HotelSpecialRequests = this.enrollment.HotelSpecialRequests + ' - ' + this.bedding.Value
      } else if(this.bedding.Value) {
        this.enrollment.HotelSpecialRequests = this.bedding.Value;
      }
      if (this.photoRelease.Value){
        this.photoRelease.Value = "Agreed";
      }
      if (this.harassmentPolicy.Value){
        this.harassmentPolicy.Value = "Agreed";
      }
      if (this.enrollment.AgreedToTermsAndConditions) {
        this.enrollment.ResponsibilityStatement = true;
      }
      if (this.attendee.TravelType === undefined) {
        this.attendee.TravelType = 'UNK';
      }

      this.enrollmentService.createEnrollment(this.registrationService.getEnrollment({})).then(() => {
        if(this.rememberme){
          this.rememberService.setCookie(this.registrationService.getEnrollment({}).$mtcConfirmationCode, this.emailAddress.EmailAddress);
        }
        this.router.navigate(['acknowledgement']);
      }, (err) => {
        this.isSubmitting = false;

        this.errorMsg = "Error while submitting your registration.";
      });
      //this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;
    }
    //this.navigationService.forward();
    /* } else {
      this.isError = true;
      this.isSubmitting = false;
    } */
    }
  }


}
